export const memorialThemes = {
  heritage: {
    id: 'heritage',
    name: 'Heritage',
    primary: '#1A2B4C', // Navy
    accent: '#C5A880',  // Gold
    background: '#F8F7F5',
    font: 'font-serif',
    isDark: true
  },
  serene: {
    id: 'serene',
    name: 'Serene Garden',
    primary: '#064E3B', // Emerald 900
    accent: '#10B981',  // Emerald 500
    background: '#F0FDF4',
    font: 'font-sans',
    isDark: true
  },
  velvet: {
    id: 'velvet',
    name: 'Royal Velvet',
    primary: '#4C1D95', // Violet 900
    accent: '#A78BFA',  // Violet 400
    background: '#F5F3FF',
    font: 'font-serif',
    isDark: true
  },
  midnight: {
    id: 'midnight',
    name: 'Midnight Star',
    primary: '#0F172A', // Slate 900
    accent: '#38BDF8',  // Sky 400
    background: '#F8FAFC',
    font: 'font-serif',
    isDark: true
  },
  custom: {
    id: 'custom',
    name: 'Custom Legacy',
    primary: '#1A2B4C',
    accent: '#C5A880',
    background: '#F8F7F5',
    font: 'font-serif',
    isCustom: true
  }
};